const mutations = {
    setLoading(state, payload) {
        state.isLoading = payload;
    },
    addNote(state, payload) {
        state.notes = [payload, ...state.notes];
    },
    addNotes(state, payload) {
        state.notes = [...state.notes, ...payload];
        console.log("Notes updated:", state.notes);
    },
    clearNotes(state) {
        state.notes = [];
    }
}

export default mutations